import './fisca.scss';

const arrowsDown = document.getElementsByClassName("fa-circle-chevron-down");
console.log(arrowsDown);
for(let value of arrowsDown) {
  value.addEventListener('click', () => { 
    const divToWorkOn = value.parentElement.nextElementSibling;
    console.log(divToWorkOn);

    if (divToWorkOn) {
      divToWorkOn.classList.contains('hide') ? divToWorkOn.classList.remove("hide") : divToWorkOn.classList.add("hide");
    }
  })
}